import * as React from "react";
import {
  Datagrid,
  ReferenceField,
  TextField,
  RichTextField,
  BooleanField,
  TextInput,
  ReferenceInput,
  SelectInput,
  EditButton,
  DeleteWithConfirmButton,
  FunctionField,
} from "react-admin";
import CreatedByField from "../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { SourceCustomer } from "../Admin/Customer";
import { TitleExperience } from "./Constant/Constant";
import { ExcelExport } from "../../Helper/ExportExcel";
import { ExperienceNoteType } from "../../../src/Enums/ExperienceNoteType";
import { CustomDateField } from "../../Components/CustomDateField";
import PoolList from "../../Components/PoolListComponent/PoolListComponent";

const ExperienceList = props => {
  const choicesIsShown = [
    { value: "True", text: "Yes" },
    { value: "False", text: "No" },
  ];

  const filters = [
    <ReferenceInput
      label="Customer"
      source="customerId__eq"
      reference={SourceCustomer}
      sort={{ field: "id", order: "ASC" }}
      perPage={999999}
      alwaysOn
    >
      <SelectInput optionValue="id" optionText="customerName" />
    </ReferenceInput>,
    <TextInput label="Pn" source="pn__contains" alwaysOn />,
    <TextInput label="Remark" source="remark__contains" alwaysOn />,
    <SelectInput
      label="Is Shown TT"
      source="isShownTt__eq"
      choices={choicesIsShown}
      optionValue="value"
      optionText="text"
      alwaysOn
    />,
    <SelectInput
      label="Is Shown Customer"
      source="isShownCustomer__eq"
      choices={choicesIsShown}
      optionValue="value"
      optionText="text"
      alwaysOn
    />,
  ];

  // get plain text from html string
  const getText = html => {
    var divContainer = document.createElement("div");
    divContainer.innerHTML = html;
    return divContainer.textContent || divContainer.innerText || "";
  };

  const exporter = (records, fetchRelatedRecords) => {
    // will call dataProvider.getMany('cdmaircraft', { ids: records.map(record => record.aircraftId) }), ignoring duplicate and empty aircraftId
    fetchRelatedRecords(records, "customerId", SourceCustomer).then(customer => {
      const data = records.map(record => ({
        //...record,
        Customer: customer[record.customerId]?.customerName,
        Pn: record.pn,
        Remark: getText(record.remark),
        "Is Shown TT": record.isShownTt,
        "Is Shown Customer": record.isShownCustomer,
        "Created By": record.createdBy,
        "Created Date": record.createdDate,
        "Updated By": record.updatedBy,
        "Updated Date": record.updatedDate,
      }));

      const columns = Object.keys(data[0]).map(record => ({ header: record }));

      ExcelExport(columns, data, "Experience List");
    });
  };

  return (
    <PoolList {...props} bulkActionButtons={false} exporter={exporter} title={TitleExperience.list} filters={filters}>
      <Datagrid>
        <ReferenceField label="Customer" source="customerId" reference={SourceCustomer} link={false}>
          <TextField source="customerName" />
        </ReferenceField>
        <TextField source="pn" />
        <RichTextField source="remark" />
        <FunctionField
          label="Note Type"
          render={(record: any) => {
            return record.noteType === ExperienceNoteType.Info
              ? "Info"
              : record.noteType === ExperienceNoteType.Serviceable
                ? "Serviceable"
                : record.noteType === ExperienceNoteType.Unserviceable
                  ? "Core Unit"
                  : record.noteType === ExperienceNoteType.Shop
                    ? "Shop"
                    : "Unknown";
          }}
        />

        <BooleanField source="isShownTt" />
        <BooleanField source="isShownCustomer" />
        <CreatedByField source="createdBy" link={false} />
        <CustomDateField source="createdDate" showTime />
        <CreatedByField source="updatedBy" link={false} />
        <CustomDateField source="updatedDate" showTime />
        <EditButton />
        <DeleteWithConfirmButton />
      </Datagrid>
    </PoolList>
  );
};

export default ExperienceList;
